import React, { Component } from 'react'
import axios from 'axios';
import { 
  Link
} from 'react-router-dom'
import {
  Modal,
} from 'antd';

import moment from "moment";

import LS_SERVICE from '../../utils/localStorage';
import Asideleft from '../../components/aside/asideleft'
import SmartEmrMedia from '../../components/smart-emr-float/SmartEmrMedia';
import {
  GET_SMART_EMR_DATA_PATIENT,
  GET_SMART_EMR_DATA_THIS_VISIT,
  LOADER_RED
} from '../../utils/constant';

export default class MySmartEMR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smartemrdatalist: [],
      smartemrfilled: false,
      thisInitialDataModal: false,
      thisInitialData: {},
      allInitialDataModal: false,
      allInitialData: []
    }
  }

  async componentDidMount() {
    axios.defaults.headers.common["Authorization"] = LS_SERVICE.get("token");
    const { match: { params } } = this.props;
    const { hospital_id, patient_id, reference_id } = params;

    axios.post(GET_SMART_EMR_DATA_PATIENT, {patient_id: patient_id, hospital_id: hospital_id, type: 'fulldate'}).then(smartEmrDataSuccess => {
      if(smartEmrDataSuccess?.data?.data?.length > 0){
        this.setState({
          smartemrdatalist: smartEmrDataSuccess?.data?.data,
          smartemrfilled: true
        })
      }
    });
  }

  viewThisInitialData(smart_emr_data){
    this.setState({
      thisInitialDataModal: true,
      thisInitialData: smart_emr_data
    })
  }

  viewAllInitialData(smart_emr_data){
    this.setState({
      allInitialDataModal: true,
      allInitialData: []
    })
    axios.post(GET_SMART_EMR_DATA_THIS_VISIT, {reference_id: smart_emr_data.reference_id, reference_type: smart_emr_data.reference_type}).then(smartEmrDataSuccess => {
      if(smartEmrDataSuccess?.data?.data?.length > 0){
        this.setState({
          allInitialData: smartEmrDataSuccess?.data?.data,
        })
      }
    });
  }

  renderData = (data) => {
    if (!this.hasContent(data)) return null;

    if (
      typeof data === "object" &&
      data !== null &&
      Object.values(data).every(v => 
        typeof v === "string" || 
        (Array.isArray(v) && v.every(item => typeof item === "string"))
      )
    ) {
      return (
        <>
          {Object.entries(data).map(([key, value]) =>
            this.hasContent(value) ? (
              <div key={key} style={{ marginBottom: "15px" }}>
                {/* Heading on its own line */}
                <strong style={{ display: "block" }}>
                  {this.formatHeading(key)}:
                </strong>
                
                {/* Values stacked with commas */}
                <div style={{ paddingLeft: "5px" }}>
                  {Array.isArray(value) ? (
                    value.map((item, index) => (
                      <div key={index}>
                        {item}{index < value.length - 1 ? "," : ""}
                      </div>
                    ))
                  ) : (
                    <div>{value}</div>
                  )}
                </div>
              </div>
            ) : null
          )}
        </>
      );
    }
    return null;
  };

  hasContent = (value) => {
    if (value == null) return false;

    // String check (Add this!)
    if (typeof value === "string") return value.trim().length > 0;

    // Array check
    if (Array.isArray(value)) {
      if (value.length === 0) return false;
      return value.some(item => this.hasContent(item));
    }

    // Object check
    if (typeof value === "object") {
      const values = Object.values(value);
      return values.some(v => this.hasContent(v));
    }
  
    return !!value; // Fallback for numbers/booleans
  };

  formatHeading = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  
  render() {
    const { smartemrfilled, smartemrdatalist} = this.state;
    return (
      <>
        <Asideleft />
        <div className="content-wrapper">
          <div className="container-fluid emrfrm ">
            <div className="row">
              <div className="col-12">
                <div className="float-left">
                  <h1 className="page-title mb-0">MySmart EMR Log</h1>
                </div>
              </div>
            </div>
            {
              smartemrdatalist.length > 0 
            ? 
              (
                smartemrdatalist.map(smart_emr_data => (
                  <div className="row single_page mt-4">
                    <div className="col-12">
                      <div className="accordion soap_accordion py-2" id="accordionExample">
                        <div className="card smartemr-card mb-0" style={{ border: 'solid 1px #ddd1d1', backgroundColor: '#f6f8fa', borderRadius: 6 }}>
                          <div className="card-header p-0 smartemr-grey-head" id="smartEmrAccordion" style={{ border: 'none', backgroundColor: '#f6f8fa' }}>
                            <button className="btn btn-block text-left collapsed arrow float-right mb-0 smartemr-grey-head" type="button" data-toggle="collapse" data-target={"#collapse_smart_emr_data"+smart_emr_data.id} aria-expanded="false" aria-controls={"collapse_smart_emr_data"+smart_emr_data.id} style={{ backgroundColor: '#f6f8fa' }}>
                              <div className='row align-items-center'>
                                <span className='text-bold col-3'>
                                  {smart_emr_data?.staff_title == null ? <>Dr. {smart_emr_data?.doctor_name}</> : <>{smart_emr_data?.staff_title} {smart_emr_data?.doctor_name}</>}
                                  <br />
                                  <small className='text-muted'>{smart_emr_data?.speciality_name}</small>
                                </span>
                                <span className='col-3'>
                                  Consult Date: {moment(smart_emr_data?.token_date).format('DD MMM, YYYY')}
                                </span>
                                <span className='col-3'>
                                  Generated At: {moment(smart_emr_data?.smart_emr_generated_at).format('DD MMM, YYYY | h:mm A')}
                                </span>
                                <span className='col-3 text-right d-flex align-items-center justify-content-end' style={{ gap: 16 }}>
                                  {(smart_emr_data?.audio_url || smart_emr_data?.audio_path || smart_emr_data?.file_url) && (
                                    <span onClick={(e) => e.stopPropagation()}>
                                      <SmartEmrMedia item={smart_emr_data} />
                                    </span>
                                  )}
                                  {smart_emr_data?.mysmart_emr_count > 1 && (
                                    <i className="icon_info" onClick={(e) => { e.stopPropagation(); this.viewAllInitialData(smart_emr_data); }} style={{width: "18px", height: "18px", cursor: 'pointer'}} title="View all"></i>
                                  )}
                                </span>
                              </div>
                            </button>
                          </div>
                          <div id={"collapse_smart_emr_data"+smart_emr_data.id} className="collapse" aria-labelledby="smartEmrAccordion" >
                            <div className='row pt-3 mb-2 ml-2 mr-2' style={{ borderTop: '1px solid #ddd1d1' }}>
                              <div className='col-12'>
                                {this.renderData(JSON.parse(smart_emr_data?.overall_visit_summary))}
                                {smart_emr_data?.initial_data && smart_emr_data?.initial_data != "" && (
                                  <pre style={{ textAlign: 'justify', whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginTop: 12, marginBottom: 0, fontFamily: 'inherit', fontSize: 13.5, lineHeight: 1.6, color: '#333' }}>
                                    {smart_emr_data.initial_data}
                                  </pre>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )
            :
              <div className="row single_page mt-4">
                <div className="col-12">
                  <div className="accordion soap_accordion py-2">
                    <div className="card medicines-card mb-0">
                      <div className="card-header p-0 med-card-head">
                        <button className="btn btn-block text-center collapsed float-right mb-0 custom-card-pink" type="button">
                          No results found
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

            <Modal
              destroyOnClose={true}
              title="Input Data"
              open={this.state.thisInitialDataModal}
              footer={false}
              width={850}
              onCancel={(e) => this.setState({ thisInitialDataModal: false, thisInitialData: {} })}
              bodyStyle={{ maxHeight: '70vh', overflowY: 'auto', padding: '16px 20px' }}
            >
              {(this.state.thisInitialData?.audio_url || this.state.thisInitialData?.audio_path || this.state.thisInitialData?.file_url) && (
                <div style={{ marginBottom: 12 }}>
                  <SmartEmrMedia item={this.state.thisInitialData} />
                </div>
              )}
              <pre style={{ textAlign: 'justify', whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginBottom: 0, fontFamily: 'inherit', fontSize: 13.5, lineHeight: 1.6, color: '#333' }}>
                {this.state.thisInitialData?.initial_data}
              </pre>
            </Modal>

            <Modal
              destroyOnClose={true}
              title="MySamrt EMR Log"
              open={this.state.allInitialDataModal}
              footer={false}
              width="70%"
              onCancel={(e) => this.setState({ allInitialDataModal: false, allInitialData: [] })}
            >
                {this.state.allInitialData.length > 0 && (
                  this.state.allInitialData.map(smart_emr_data => (
                    <div className="row single_page">
                      <div className="col-12">
                        <div className="accordion soap_accordion py-2" id="accordionExample">
                          <div className="card smartemr-card mb-0" style={{ border: 'solid 1px #ddd1d1', backgroundColor: '#f6f8fa', borderRadius: 6 }}>
                            <div className="card-header p-0 smartemr-grey-head" id="smartEmrAccordion" style={{ border: 'none', backgroundColor: '#f6f8fa' }}>
                              <button className="btn btn-block text-left collapsed arrow float-right mb-0 smartemr-grey-head" type="button" data-toggle="collapse" data-target={"#collapse_smart_emr_data_hx"+smart_emr_data.id} aria-expanded="false" aria-controls={"collapse_smart_emr_data_hx"+smart_emr_data.id} style={{ backgroundColor: '#f6f8fa' }}>
                                <div className='row align-items-center'>
                                  <span className='col-8'>
                                    Generated At: {moment(smart_emr_data?.createdAt).format('DD MMM, YYYY | h:mm A')}
                                  </span>
                                  <span className='col-4 text-right d-flex align-items-center justify-content-end' style={{ gap: 12 }}>
                                    {(smart_emr_data?.audio_url || smart_emr_data?.audio_path || smart_emr_data?.file_url) && (
                                      <span onClick={(e) => e.stopPropagation()}>
                                        <SmartEmrMedia item={smart_emr_data} />
                                      </span>
                                    )}
                                  </span>
                                </div>
                              </button>
                            </div>
                            <div id={"collapse_smart_emr_data_hx"+smart_emr_data.id} className="collapse" aria-labelledby="smartEmrAccordion" >
                              <div className='row pt-3 mb-2 ml-2 mr-2' style={{ borderTop: '1px solid #ddd1d1' }}>
                                <div className='col-12'>
                                  {this.renderData(JSON.parse(smart_emr_data?.overall_visit_summary))}
                                  {smart_emr_data?.initial_data && smart_emr_data?.initial_data != "" && (
                                    <pre style={{ textAlign: 'justify', whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginTop: 12, marginBottom: 0, fontFamily: 'inherit', fontSize: 13.5, lineHeight: 1.6, color: '#333' }}>
                                      {smart_emr_data.initial_data}
                                    </pre>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
            </Modal>
          </div>
        </div>
      </>
    )
  }
}
